import {GET_ZP_INFO, GET_ZP_RANK} from '../constant/eventbus'
import {getJSON} from '../api/myaxios'
import isUndefined from 'lodash/isUndefined'
import {error_event} from '../tools/mgtv/analysis'
import set_title from '../tools/set-title'
import {setShare} from '../tools/mgtv/share'
import setTitle from '../tools/set-title'

function get_zp_info() {
  return getJSON('//vipact3.api.mgtv.com/api/v1/zp/zp/info', {
    share_id: window.gact.share_id,
    ticket: window.$bus.user.ticket,
    act_name: window.rootdata.act_name
  }).then(res => {
    if (!res) {
      return;
    }
    if (res.ret === 0) {
      window.$bus.zp_info = res.data;
      const share = res.data.share;
      if (share) {
        setShare({
          title: share.title,
          desc: share.desc,
          img: share.img,
        });
      }
      setTitle(`${window.$bus.zp_info.zpinfo.nickname}给你赠送了《${window.$bus.zp_info.zpinfo.part_name}》`)
    } else {
      window.$toast(res.msg);
    }
  })
}


function get_zp_rank() {
  return getJSON('//vipact3.api.mgtv.com/api/v1/zp/vrs/rank', {}).then(res => {
    if (!res) {
      return;
    }
    if (res.ret === 0) {
      window.$bus.zp_rank = res.data.list;
    }
  })
}

export default {
  install: function (EventBus) {
    EventBus.$on(GET_ZP_INFO, () => {
      get_zp_info()
    });

    EventBus.$on(GET_ZP_RANK, () => {
      get_zp_rank()
    });
  }
}





// WEBPACK FOOTER //
// ./src/EventBus/EventZP.js